module.exports = __webpack_public_path__ + "static/media/hihat.4ba39e07.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/hihat.wav
// module id = 179
// module chunks = 0